import { useEffect, useState } from 'react';
import memoizeOnce from 'memoize-one';
import useConfig from './useConfig';
import { useUserData } from '../components/UserDataProvider';

// NB: `username` is added to this function signature to prevent
//     accidental memoization of the API responses between different
//     user sessions
// eslint-disable-next-line no-unused-vars
async function fetchAvatarUrlForUser(expertsApi, username) {
  let responseAvatarUrl;

  try {
    const result = await fetch(`${expertsApi}/profiles/me/avatar`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include'
    });
    const json = await result.json();
    const { url } = json;
    responseAvatarUrl = url;
  } catch (e) {
    // Do nothing, service return 404 if avatar not set
    responseAvatarUrl = '';
  }

  return responseAvatarUrl;
}

export const memoizedFetchAvatarUrl = memoizeOnce(fetchAvatarUrlForUser);

export default function usePartnerAvatarUrl(enabled) {
  const [loading, setLoading] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState('');
  const { expertsApi } = useConfig();
  const { userData = {} } = useUserData();
  const { username } = userData || {};

  async function fetchAvatarUrl(expertsApi) {
    return memoizedFetchAvatarUrl(expertsApi, username);
  }

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const responseAvatarUrl = await fetchAvatarUrl(expertsApi);
      setAvatarUrl(responseAvatarUrl);
      setLoading(false);
    }

    if (enabled) {
      fetchData();
    }
  }, [enabled, expertsApi]);

  return { loading, avatarUrl, enabled };
}
